import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24">
    <g transform="translate(4 3)">
      <path
        d="M3.3 13.7c-1.2-1.2-2-2.9-2-4.7S2 5.5 3.2 4.3c1-1 1-2.7 0-3.8-1-1-2.6-1-3.6 0-2 2.2-3.3 5.2-3.3 8.5s1.3 6.3 3.4 8.5c1 1 2.6 1 3.6 0 .9-1.1.9-2.7 0-3.8z"
        fill="#fae501"
      />
      <path
        d="M3.3 4.3c1.2-1.3 2.8-2 4.6-2s3.4.8 4.6 1.9c1 1.1 2.6 1.1 3.6 0 1-1 1-2.7 0-3.8C13.9-1.6 11-3 7.8-3S1.7-1.6-.4.5c-1 1-1 2.7 0 3.8 1 .9 2.6.9 3.7 0z"
        fill="#4fb5e1"
      />
      <path
        d="M12.4 13.7c-1.2 1.3-2.8 2-4.6 2-1.8 0-3.4-.8-4.6-2-1-1.1-2.6-1.1-3.6 0-1 1-1 2.7 0 3.8 2.1 2.1 5 3.5 8.2 3.5s6.1-1.4 8.2-3.5c1-1 1-2.7 0-3.8-1-1-2.6-1-3.6 0z"
        fill="#f05751"
      />
      <ellipse cx="1.4" cy="2.4" rx="2.5" ry="2.6" fill="#0681b6" />
      <ellipse cx="1.4" cy="15.6" rx="2.5" ry="2.6" fill="#cd4739" />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/logo-label.es6.js